import React from 'react';
import { ShieldAlert, RefreshCcw } from 'lucide-react';
import { useCurrentUser } from '../../contexts/AuthContext';
import { useTenant } from '../../contexts/TenantContext';
import { cn } from '../../lib/utils';

export const MaintenanceBanner: React.FC = () => {
  const { isMaintenanceMode, retrySync, isCheckingHealth } = useCurrentUser();
  const { brand } = useTenant();

  if (!isMaintenanceMode) return null;

  return (
    <div className="bg-amber-600 text-white px-4 py-2 flex items-center justify-center gap-4 text-sm font-medium animate-in fade-in slide-in-from-top duration-300">
      <div className="flex items-center gap-2">
        <ShieldAlert size={16} className={cn("animate-pulse", isCheckingHealth && "animate-spin")} />
        <span>{brand.name} Servers are temporarily under maintenance or unreachable. Some features may be limited.</span>
      </div>
      <button 
        onClick={() => retrySync(false)}
        disabled={isCheckingHealth}
        className={cn(
          "flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-none transition-all border-2 border-black dark:border-white border-white/10 dark:bg-slate-900",
          isCheckingHealth && "opacity-50 cursor-not-allowed scale-95"
        )}
      >
        <RefreshCcw size={12} className={cn(isCheckingHealth && "animate-spin")} />
        <span>{isCheckingHealth ? 'Checking...' : 'Check Again'}</span>
      </button>
    </div>
  );
};
